import { render } from "./MarketingModal.vue?vue&type=template&id=6d5fe628&scoped=true"
import script from "./MarketingModal.vue?vue&type=script&lang=js"
export * from "./MarketingModal.vue?vue&type=script&lang=js"

import "./MarketingModal.vue?vue&type=style&index=0&id=6d5fe628&lang=scss&scoped=true"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d5fe628"]])

export default __exports__